import getAll from "./get-all"
import remove from "./delete"
import updateDeckSet from "./update-deck-set"
import updateDeck from "./update-deck"
import create from "./create"
import get from "./get"
import getSpecialDeck from "./get-special-deck"
import saveConfidenceIndex from "./save-confidence-index"

const FlashcardsAPI = {
  get,
  getAll,
  delete: remove,
  updateDeckSet,
  updateDeck,
  create,
  getSpecialDeck,
  saveConfidenceIndex,
}

export default FlashcardsAPI
